// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item {
  flex: 1;
  display: block;
  margin: 15px;
  border: solid 1px #ccc;
  height: 300px;
  min-width: 220px;
  max-width: 220px;
  width: 220px;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.1s;
}

  .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item:hover {
    box-shadow: 0px 3px 15px 3px rgba(0, 0, 0, 0.5);
  }

  .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item a {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item a .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__imgTop {
      background: linear-gradient(to top, #596169 20%, #5961696b);
      height: 50%;
      width: 100%;
      position: relative;
    }

  .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item a .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__imgTop .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__img {
        height: 100%;
        width: 100%;
        background-size: cover;
        background-position: center;
        background-color: white;
      }

  .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item a .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__imgTop .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__iconImage {
        font-size: 30px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

  .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item a .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__bottomContent {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 15px;
      width: 100%;
      height: 50%;
      background: linear-gradient(to top, #41474d 20%, #596169);
      color: white;
      text-align: center;
    }

  .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item a .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__bottomContent .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__title .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__itemName {
          font-size: 18px;
          font-weight: bold;
        }

  .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item a .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__bottomContent .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__title .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__trigram {
          color: #adb2b8;
          font-weight: bold;
          font-size: 16px;
        }

  .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item a .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__bottomContent .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__title .app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__date {
          color: #848484;
        }
`, "",{"version":3,"sources":["webpack://./app/pages/Project/ProjectsHomePage/ProjectCard/ProjectCard.module.scss"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AAiEtB;;EA/DE;IACE,+CAA+C;EACjD;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;EAqDhC;;EAnDE;MACE,2DAA2D;MAC3D,WAAW;MACX,WAAW;MACX,kBAAkB;IAiBpB;;EAfE;QACE,YAAY;QACZ,WAAW;QACX,sBAAsB;QACtB,2BAA2B;QAC3B,uBAAuB;MACzB;;EAEA;QACE,eAAe;QACf,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,gCAAgC;MAClC;;EAGF;MACE,aAAa;MACb,sBAAsB;MACtB,6BAA6B;MAC7B,aAAa;MACb,WAAW;MACX,WAAW;MACX,yDAAyD;MACzD,YAAY;MACZ,kBAAkB;IAkBpB;;EAfI;UACE,eAAe;UACf,iBAAiB;QACnB;;EAEA;UACE,cAAc;UACd,iBAAiB;UACjB,eAAe;QACjB;;EAEA;UACE,cAAc;QAChB","sourcesContent":[".item {\n  flex: 1;\n  display: block;\n  margin: 15px;\n  border: solid 1px #ccc;\n  height: 300px;\n  min-width: 220px;\n  max-width: 220px;\n  width: 220px;\n  border-radius: 10px;\n  overflow: hidden;\n  transition: all 0.1s;\n\n  &:hover {\n    box-shadow: 0px 3px 15px 3px rgba(0, 0, 0, 0.5);\n  }\n\n  a {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    .imgTop {\n      background: linear-gradient(to top, #596169 20%, #5961696b);\n      height: 50%;\n      width: 100%;\n      position: relative;\n\n      .img {\n        height: 100%;\n        width: 100%;\n        background-size: cover;\n        background-position: center;\n        background-color: white;\n      }\n\n      .iconImage {\n        font-size: 30px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n      }\n    }\n\n    .bottomContent {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-around;\n      padding: 15px;\n      width: 100%;\n      height: 50%;\n      background: linear-gradient(to top, #41474d 20%, #596169);\n      color: white;\n      text-align: center;\n\n      .title {\n        .itemName {\n          font-size: 18px;\n          font-weight: bold;\n        }\n\n        .trigram {\n          color: #adb2b8;\n          font-weight: bold;\n          font-size: 16px;\n        }\n\n        .date {\n          color: #848484;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__item`,
	"imgTop": `app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__imgTop`,
	"img": `app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__img`,
	"iconImage": `app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__iconImage`,
	"bottomContent": `app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__bottomContent`,
	"title": `app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__title`,
	"itemName": `app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__itemName`,
	"trigram": `app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__trigram`,
	"date": `app-pages-Project-ProjectsHomePage-ProjectCard-___ProjectCard-module__date`
};
export default ___CSS_LOADER_EXPORT___;
